export default __webpack_public_path__ + "static/char-s-50-zh-Hant-d8f24bb221ebeeee2fee2510c9f510e3.png";